import React, { useEffect, useState } from 'react';
import { getMissions, createRidePlay, getStatusRide, getBotDetails, rideTerminate, gptCheckPoint } from '@services/api';
import CountdownTimer from './Bottomheader/CountdownTimer';
import { SmallGamepad } from '@util/svgicon';
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "@redux/actionTypes";
import { getModeByUrl } from "@util/config";
import { toast } from "react-toastify";
import toastErrorMessages from "@util/toastErrorMessage";
import { safeLocalStorage } from "@utils/localstorage";
const ENDTIME = 15

const TestCamera = () => {
  const dispatch = useDispatch();
  const [endTime, setEndTime] = useState('')
  const user = useSelector((state) => state?.setUserDetails?.user)
  const userDetails = safeLocalStorage.getItem("token")
  const gptErrorToast = useSelector((state) => state.testDriveDetails.gptErrorToast)
  const gptMessageToast = useSelector((state) => state.testDriveDetails.gptMessageToast)
  const gptScanCheckPointResponce = useSelector((state) => state.testDriveDetails.gptScanCheckPointResponce)
  const scanCheckPointList = useSelector((state) => state.testDriveDetails.scanCheckPointList)
  const allScanCheckpoint = useSelector((state) => state.testDriveDetails.allScanCheckpoint)
  const testDriveComplect = useSelector((state) => state.testDriveDetails.testDriveComplect);
  const testDriveComplectSevenPoint = useSelector((state) => state.testDriveDetails.testDriveComplectSevenPoint);

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (gptMessageToast || gptErrorToast) {
      setTimeout(() => {
        gptSuccessMessageHandler()
        gptErrorHandler()
      }, 10000)
    }
  }, [gptMessageToast, gptErrorToast])

  const init = async () => {
    const tournamentData = safeLocalStorage.getItem('tournamentData')
    const allBots = await getBotDetails();
    if (allBots?.length > 0) {
      const findBot = allBots?.find((i) => i?.device_ref_id === tournamentData?.deviceId && i?.drive_mode === 'trial')
      if (findBot?.device_ref_id) {
        await checkCreateRideData(findBot?.device_ref_id)
      } else {
        const test_ready = allBots?.filter((i) => i.status === "test_ready" && i?.drive_mode === 'trial');
        if (test_ready.length > 0) {
          const randomBotChioce = await getRandomBotChioce(test_ready);
          if (randomBotChioce?.device_ref_id) {
            const tournamentData = {
              deviceId: randomBotChioce?.device_ref_id,
              hardware_version: randomBotChioce?.hardware_version,
            };
            safeLocalStorage.setItem("tournamentData", tournamentData);
            await new Promise((resolve) => setTimeout(resolve, 2000));
            await checkCreateRideData(randomBotChioce?.device_ref_id)
          }
        } else {
          toast.error(toastErrorMessages.noTestReadyBot, { position: "top-right" });
        }
      }
    } else {
      toast.error(toastErrorMessages.noTestReadyBot, { position: "top-right" });
    }
  }

  const checkCreateRideData = async (device_ref_id) => {
    const mission = await getMissions(device_ref_id)
    if (mission?.data?.missions?.length > 0) {
      const findPveMission = mission?.data?.missions.find((i) => i?.type === 'pve')
      if (getModeByUrl() === 'playgame' && findPveMission?.id) {
        rideCreate(findPveMission?.id)
      } else {
        const testdriveLoadingScreenElement = document.getElementById('testdrive-loading-screen');
        if (testdriveLoadingScreenElement) {
          testdriveLoadingScreenElement.style.display = 'none'
        }
        toast.error(toastErrorMessages.missionNotFound, { position: "top-right" })
      }
    } else if (mission?.data?.error) {
      const testdriveLoadingScreenElement = document.getElementById('testdrive-loading-screen');
      if (testdriveLoadingScreenElement) {
        testdriveLoadingScreenElement.style.display = 'none'
      }
      toast.error(`${mission?.data?.error}`, {
        position: "top-right",
      });
    }
  }

  const getRandomBotChioce = (test_ready) => {
    const randomIndex = Math.floor(Math.random() * test_ready?.length);
    return test_ready[randomIndex];
  };

  const rideCreate = async (missionId) => {
    const tournamentData = safeLocalStorage.getItem('tournamentData')
    const currentDayTime = new Date();
    const currentRideTime = currentDayTime.toUTCString();
    const rideData = {
      ride: {
        mission_id: missionId,
        start_time: currentRideTime,
        time_credit: 1
      }
    }
    const createRidePlayData = await createRidePlay(rideData)
    if (createRidePlayData?.ride) {
      dispatch({
        type: actionTypes.CREATE_RIDE,
        payload: createRidePlayData?.ride
      })
      const agoratoken = {
        rtm_token: createRidePlayData?.ride?.agora?.rtm_token,
        rtc_token: createRidePlayData?.ride?.agora?.rtc_token,
        channel: createRidePlayData?.ride?.agora?.channel,
        uid: createRidePlayData?.ride?.agora?.uid
      }
      await safeLocalStorage.setItem(`agoratoken_${tournamentData?.deviceId}`, agoratoken)
      const startTime = createRidePlayData.ride.start_time;
      dispatch({
        type: actionTypes.RIDE_START_TIME,
        payload: startTime
      })
      const startTimes = new Date(startTime);
      const endTime = new Date(startTimes.getTime() + (ENDTIME * 60 * 1000));
      const UtcEndTime = endTime.toISOString();
      const endUnixTimestamp = Date.parse(UtcEndTime)
      setEndTime(endUnixTimestamp)
      if (createRidePlayData?.ride?.id) {
        dispatch({
          type: actionTypes.TESTDRIVE_RIDE_ID,
          payload: createRidePlayData?.ride?.id
        })
        await getCheckpoint(createRidePlayData?.ride?.id)
      }
    } else {
      const activeRide_Id = createRidePlayData?.ride_ids && createRidePlayData?.ride_ids[0]
      if (activeRide_Id) {
        dispatch({
          type: actionTypes.TESTDRIVE_RIDE_ID,
          payload: activeRide_Id
        })
        const agoraTokenLocalStoarage = safeLocalStorage.getItem(`agoratoken_${tournamentData?.deviceId}`)
        if (agoraTokenLocalStoarage) {
          const active_Ride = await getStatusRide(activeRide_Id)
          if (['active', 'visible'].includes(active_Ride?.ride?.status) && active_Ride?.ride?.user_id == userDetails?.user?.id) {
            const startTime = active_Ride.ride.start_time;
            dispatch({
              type: actionTypes.RIDE_START_TIME,
              payload: startTime
            })
            const startTimes = new Date(startTime);
            const endTime = new Date(startTimes.getTime() + ENDTIME * 60 * 1000);
            const UtcEndTime = endTime.toISOString();
            const endUnixTimestamp = Date.parse(UtcEndTime)
            setEndTime(endUnixTimestamp)
            if (active_Ride?.ride?.id) {
              dispatch({
                type: actionTypes.TESTDRIVE_RIDE_ID,
                payload: active_Ride?.ride?.id
              })
              await getCheckpoint(active_Ride?.ride?.id)
            }
          }
        } else {
          const terminateRide = await rideTerminate(activeRide_Id)
          if (terminateRide?.ride && terminateRide?.ride?.status === 'terminated') {
            safeLocalStorage.removeItem(`agoratoken_${tournamentData?.deviceId}`)
            await new Promise((resolve) => setTimeout(resolve, 6000));
            console.log("new Ride create=====================");
            // init();
          }
        }
      } else {
        const testdriveLoadingScreenElement = document.getElementById('testdrive-loading-screen');
        if (testdriveLoadingScreenElement) {
          testdriveLoadingScreenElement.style.display = 'none'
        }
        toast.error(`${createRidePlayData?.error}`, { position: "top-right" });
        safeLocalStorage.removeItem('tournamentData')
        safeLocalStorage.removeItem('keyboradKey')
        safeLocalStorage.removeItem('headlight')
        safeLocalStorage.removeItem(`keyBinding_${user?.id}`)
      }
    }
  }


  const getCheckpoint = async (testDriveRideId) => {
    const imagePath = {
      "image_url": `https://frodobots-image-api.s3.ap-southeast-1.amazonaws.com/images/Cj.Ferrer_2023-12-13T09:06:12.787740.jpg`
    }
    const getResponce = await gptCheckPoint(imagePath, testDriveRideId)
    if (getResponce?.data && getResponce?.data?.checkpoints_list?.length > 0) {
      dispatch({
        type: actionTypes.ALL_SCAN_CHECKPOINT_LIST,
        payload: getResponce.data?.checkpoints_list
      })
      dispatch({
        type: actionTypes.SCAN_CHECKPOINT_LIST,
        payload: getResponce?.data?.checkpoints_list_scanned
      })
    } else if (getResponce?.data?.error) {
      toast.error(getResponce?.data?.error, { position: "top-right" });
    }
  }

  const gptSuccessMessageHandler = () => {
    dispatch({
      type: actionTypes.GPT_MESSAGE_TOAST,
      payload: false
    })
  }

  const gptErrorHandler = () => {
    dispatch({
      type: actionTypes.GPT_ERROR_TOAST,
      payload: false
    })
  }

  const finishTestDriveHandler = () => {
    dispatch({
      type: actionTypes.TEST_DRIVE_COMPLETE_SEVEN_POINT,
      payload: false
    })
    dispatch({
      type: actionTypes.TEST_DRIVE_COMPLECT,
      payload: true
    })
  }

  const continousTestDriveHandler = () => {
    safeLocalStorage.removeItem(`score_${user?.id}`)
    dispatch({
      type: actionTypes.TEST_DRIVE_COMPLETE_SEVEN_POINT,
      payload: false
    })
  }

  let leftScanCheckPoint;
  const totalScans = 7;
  if (gptScanCheckPointResponce?.checkpoints_list_scanned?.length > 7) {
    leftScanCheckPoint = gptScanCheckPointResponce?.checkpoints_list?.length - gptScanCheckPointResponce?.checkpoints_list_scanned?.length
  } else {
    leftScanCheckPoint = totalScans - gptScanCheckPointResponce?.checkpoints_list_scanned?.length;
  }

  let errormsg = `Oops! There's a problem with the checkpoint scan. Please re-do the scan.`
  if (gptScanCheckPointResponce?.status === 422 || gptScanCheckPointResponce?.status === 500) {
    errormsg = `Oops! There's a problem with the checkpoint scan. Please re-do the scan.`
  } else if (gptScanCheckPointResponce?.status === 409) {
    errormsg = `Looks like you've already visited checkpoint #${gptScanCheckPointResponce?.label} previously. Still ${leftScanCheckPoint} more to go!`
  } else if (gptScanCheckPointResponce?.status === 400) {
    errormsg = `All checkpoints are scanned`
  }

  return (
    <div className="testgame_camara_container" >
      <video id="front-cam" className="front_camera_testdrive" />
      <div className="testgame_back_camara">
        <video id="back-cam" className="back_camera_testdrive" />
      </div>
      <div className="testdrive-timer-container">
        <CountdownTimer
          endTime={endTime}
        />
      </div>
      <div className="gameremote-icon">
        <SmallGamepad />
      </div>
      {(gptMessageToast && !testDriveComplect) &&
        <div className="testdrive-checkpoint-message">
          <div className='checkpoint-msg-container'>
            <div className='checkpoint-section'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_3432_5718" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_3432_5718)">
                  <path d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5ZM14.65 14H18V8H12.75L12.35 6H7V12H14.25L14.65 14Z" fill="#FAFAFA" />
                </g>
              </svg>
              <p className='scancheckpoint-msg-letter'>Scan complete! {leftScanCheckPoint} more to go!</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={gptSuccessMessageHandler}>
                <path d="M7.2 18L6 16.8L10.8 12L6 7.2L7.2 6L12 10.8L16.8 6L18 7.2L13.2 12L18 16.8L16.8 18L12 13.2L7.2 18Z" fill="#FAFAFA" />
              </svg>
            </div>
          </div>
        </div>
      }
      {(gptErrorToast && !testDriveComplect) &&
        <div className="testdrive-checkpoint-error">
          <div className='checkpoint-error-container'>
            <div className='checkpoint-section-error'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_3432_5440" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_3432_5440)">
                  <path d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5ZM14.65 14H18V8H12.75L12.35 6H7V12H14.25L14.65 14Z" fill="#1C1B1F" />
                </g>
              </svg>
              <p className='scancheckpoint-error-letter'>{errormsg}</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={gptErrorHandler}>
                <path d="M7.2 18L6 16.8L10.8 12L6 7.2L7.2 6L12 10.8L16.8 6L18 7.2L13.2 12L18 16.8L16.8 18L12 13.2L7.2 18Z" fill="black" />
              </svg>
            </div>
          </div>
        </div>
      }
      {testDriveComplectSevenPoint &&
        <div className='absolute top-[11%] left-[50%] -translate-x-1/2 z-10'>
          <div className='w-[720px] h-[64px] flex pl-[24px] pr-[8px] py-[8px] items-center gap-[24px] rounded-[500px] bg-[#25BD66]'>
            <div className='flex items-center gap-[16px]'>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M15.4067 4.47059H22.5V16.8235H13.6333L13.1267 14.3529H6.03333V23H3.5V2H14.9L15.4067 4.47059ZM14.9 14.3529H17.4333V11.8824H19.9667V9.41176H17.4333V6.94118H14.9V9.41176L13.6333 6.94118V4.47059H11.1V6.94118H8.56667V4.47059H6.03333V6.94118H8.56667V9.41176H6.03333V11.8824H8.56667V9.41176H11.1V11.8824H13.6333V9.41176L14.9 11.8824V14.3529ZM11.1 9.41176V6.94118H13.6333V9.41176H11.1ZM14.9 9.41176H17.4333V11.8824H14.9V9.41176Z" fill="#FAFAFA" />
              </svg>
              <div className='flex flex-col'>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]'>Your test drive is complete!</p>
                <p className='w-[380px] text-[#FAFAFA] text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]'>Continue if you want to complete 10 checkpoints..</p>
              </div>
            </div>
            <div className='flex items-center gap-[8px]'>
              <button className='w-full flex h-[48px] p-[24px] justify-center items-center gap-[10px] rounded-[50px] bg-[#000]' onClick={finishTestDriveHandler}>
                <p className='text-[#FAFAFA] text-[20px] not-italic font-bold leading-[normal] tracking-[-0.4px]'>Finish</p>
              </button>
              <button className='w-full flex h-[48px] p-[24px] justify-center items-center gap-[10px] rounded-[50px] bg-[#000]' onClick={continousTestDriveHandler}>
                <p className='text-[#FAFAFA] text-[20px] not-italic font-bold leading-[normal] tracking-[-0.4px]'>Continue</p>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default TestCamera